import { createLayoutPortalToken } from '@sketch/utils'

export const header = createLayoutPortalToken('header')
